import { render, staticRenderFns } from "./ResultDistributionTab.vue?vue&type=template&id=5e666f6e&"
import script from "./ResultDistributionTab.vue?vue&type=script&lang=ts&"
export * from "./ResultDistributionTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports